export class EntInitialFilterName {
  name: string | null;
  page: number;
  size: number;
  deleted?: boolean | null;
  governmentIds?: number[] | null;
  departmentIds?: number[] | null;


  constructor(init?:Partial<EntInitialFilterName>) {
    this.deleted = false;
    this.name = null;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}
